import { j as C } from "./jsx-runtime-B6kdoens.js";
import "react";
import "./logo-svg-embed-Cp82pc6m.js";
const o = () => /* @__PURE__ */ C.jsx(
  "a",
  {
    href: "https://transfrinc.com",
    target: "_blank",
    id: "logo",
    alt: "Transfer VR Logo",
    rel: "noreferrer",
    children: /* @__PURE__ */ C.jsxs(
      "svg",
      {
        width: "141",
        height: "30",
        viewBox: "0 0 141 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
          /* @__PURE__ */ C.jsx(
            "path",
            {
              className: "logo-t",
              d: "M42.466 12.7336H38.177V20.4028C38.1543 20.6569 38.1864 20.9128 38.2712 21.1542C38.3561 21.3956 38.4919 21.6172 38.6699 21.8048C39.0778 22.127 39.5881 22.3021 40.114 22.3001C40.8974 22.3435 41.6826 22.3435 42.466 22.3001V26.5944C39.0994 26.9638 36.7272 26.6573 35.3494 25.6751C33.9717 24.6928 33.2857 22.9354 33.2914 20.4028V12.7336V8.16647V4.44311L38.177 3.0033V8.16647H42.466V12.7336Z",
              fill: "#173660"
            }
          ),
          /* @__PURE__ */ C.jsx(
            "path",
            {
              className: "logo-r",
              d: "M50.6722 11.3357C51.0742 10.2171 51.8746 9.27477 52.9291 8.67852C53.9977 8.08682 55.2096 7.78253 56.4398 7.797V13.1029C55.0386 12.9121 53.6139 13.2273 52.4362 13.9886C51.2602 14.7498 50.6722 16.0091 50.6722 17.7665V26.5817H45.7736V8.1664H50.6722V11.3357Z",
              fill: "#173660"
            }
          ),
          /* @__PURE__ */ C.jsx(
            "path",
            {
              className: "logo-a",
              d: "M73.012 8.16649H77.9106V26.5944H73.012V24.42C71.5449 26.211 69.4825 27.1079 66.825 27.1107C65.5949 27.1205 64.377 26.8737 63.2537 26.3871C62.1303 25.9004 61.1277 25.1852 60.3137 24.2898C58.5073 22.4234 57.5317 19.9407 57.5985 17.3804C57.532 14.8189 58.5074 12.335 60.3137 10.4668C61.1287 9.57286 62.1316 8.85888 63.2548 8.37301C64.378 7.88713 65.5954 7.64065 66.825 7.65017C69.4854 7.65017 71.5477 8.54708 73.012 10.3409V8.16649ZM63.9887 21.1206C65.0068 22.0558 66.3551 22.577 67.7567 22.577C69.1583 22.577 70.5066 22.0558 71.5247 21.1206C72.0254 20.6303 72.417 20.0453 72.6751 19.4019C72.9332 18.7584 73.0523 18.0704 73.025 17.3804C73.0523 16.6905 72.9332 16.0024 72.6751 15.359C72.417 14.7156 72.0254 14.1306 71.5247 13.6403C70.5066 12.705 69.1583 12.1838 67.7567 12.1838C66.3551 12.1838 65.0068 12.705 63.9887 13.6403C63.495 14.1345 63.1094 14.7207 62.8553 15.3635C62.6012 16.0063 62.4837 16.6924 62.5101 17.3804C62.4837 18.0685 62.6012 18.7546 62.8553 19.3974C63.1094 20.0402 63.495 20.6263 63.9887 21.1206V21.1206Z",
              fill: "#173660"
            }
          ),
          /* @__PURE__ */ C.jsx(
            "path",
            {
              className: "logo-n",
              d: "M92.3167 7.65006C93.2717 7.62239 94.2221 7.78841 95.1073 8.13752C95.9924 8.48662 96.7929 9.01114 97.4574 9.67755C98.8093 11.0292 99.4866 12.8958 99.4895 15.2773V26.6111H94.5909V15.8692C94.5909 14.6406 94.2493 13.7003 93.5662 13.0483C93.2016 12.7157 92.7717 12.4578 92.3023 12.2898C91.8329 12.1217 91.3335 12.0471 90.8337 12.0702C90.2749 12.0461 89.717 12.1356 89.1958 12.3329C88.6747 12.5303 88.2017 12.8311 87.8072 13.2162C87.0463 13.9774 86.6658 15.1192 86.6658 16.6415V26.5943H81.7586V8.16638H86.6572V10.2275C87.8476 8.51199 89.7341 7.65286 92.3167 7.65006Z",
              fill: "#173660"
            }
          ),
          /* @__PURE__ */ C.jsx(
            "path",
            {
              className: "logo-s",
              d: "M107.536 13.3968C107.536 13.8921 107.869 14.2909 108.539 14.5973C109.328 14.942 110.148 15.2133 110.99 15.4075C111.969 15.6471 112.932 15.9428 113.874 16.2932C114.846 16.6571 115.695 17.2763 116.325 18.0814C117.018 18.9838 117.371 20.0886 117.328 21.2129C117.371 22.0606 117.193 22.905 116.812 23.6686C116.43 24.4322 115.857 25.0904 115.145 25.5827C113.544 26.6436 111.635 27.179 109.697 27.1106C105.803 27.1106 103.146 25.6484 101.725 22.7241L105.979 20.4027C106.533 21.9979 107.772 22.7968 109.697 22.7996C111.444 22.7996 112.317 22.2707 112.317 21.2129C112.317 20.7218 111.985 20.323 111.31 20.0165C110.522 19.6661 109.703 19.3851 108.863 19.177C107.884 18.9264 106.921 18.6194 105.979 18.2577C105.018 17.8911 104.173 17.2861 103.528 16.5031C102.838 15.6492 102.483 14.5858 102.525 13.5017C102.495 12.6824 102.667 11.8681 103.026 11.1263C103.385 10.3845 103.922 9.73675 104.591 9.23685C106.072 8.16057 107.888 7.60812 109.736 7.67111C111.207 7.65285 112.659 8.00116 113.952 8.68275C115.211 9.35401 116.249 10.3565 116.948 11.575L112.771 13.7872C112.528 13.2092 112.107 12.7183 111.565 12.3817C111.023 12.0451 110.388 11.8791 109.745 11.9066C109.189 11.891 108.641 12.0372 108.171 12.3264C107.979 12.4367 107.82 12.5932 107.709 12.7807C107.598 12.9682 107.538 13.1804 107.536 13.3968V13.3968Z",
              fill: "#173660"
            }
          ),
          /* @__PURE__ */ C.jsx(
            "path",
            {
              className: "logo-f",
              d: "M128.41 4.84603C125.723 4.65013 124.382 5.69536 124.385 7.98171V8.16641H128.41V12.7335H124.385V26.5859H119.482V12.7335H119.425V8.16641H119.482V7.97751C119.482 5.36934 120.228 3.39082 121.721 2.04196C123.214 0.693102 125.444 0.105424 128.41 0.278929V4.84603Z",
              fill: "#173660"
            }
          ),
          /* @__PURE__ */ C.jsx(
            "path",
            {
              className: "logo-r",
              d: "M135.228 11.3357C135.633 10.2175 136.435 9.27571 137.489 8.67852C138.558 8.08682 139.77 7.78253 141 7.797V13.1029C139.599 12.9121 138.174 13.2273 136.996 13.9886C135.815 14.7498 135.225 16.0091 135.228 17.7665V26.5817H130.334V8.1664H135.228V11.3357Z",
              fill: "#173660"
            }
          ),
          /* @__PURE__ */ C.jsxs("g", { mask: "url(#mask1_32_1138)", children: [
            /* @__PURE__ */ C.jsx(
              "path",
              {
                className: "arrow-bottom",
                d: "M25.7425 21.4102L25.7771 17.3636C25.7771 17.3153 25.7577 17.269 25.7229 17.2345C25.6882 17.1999 25.6409 17.18 25.5912 17.1789H24.1385L8.1629 17.1285H3.96472C3.24571 17.1234 2.53903 17.3099 1.92162 17.6677C1.3042 18.0255 0.799719 18.5409 0.463089 19.1577C0.126459 19.7746 -0.0294174 20.4693 0.012431 21.1662C0.0542793 21.8631 0.292248 22.5355 0.70043 23.1102C0.924517 23.4061 1.19431 23.6667 1.50029 23.8826C2.99624 24.974 8.56931 29.0416 9.9442 29.9987C9.95711 30.0004 9.97021 30.0004 9.98312 29.9987L9.16164 24.1219L5.80223 21.8006C5.77628 21.7846 5.75651 21.7608 5.74604 21.7328C5.73557 21.7048 5.735 21.6742 5.74441 21.6458C5.75382 21.6174 5.77268 21.5929 5.79802 21.5761C5.82336 21.5593 5.85374 21.5511 5.88438 21.5529H8.80278H24.8H25.5523C25.596 21.554 25.6389 21.5404 25.6735 21.5144C25.7082 21.4884 25.7326 21.4516 25.7425 21.4102Z",
                fill: "#09A6E0"
              }
            ),
            /* @__PURE__ */ C.jsx(
              "path",
              {
                className: "arrow-top",
                d: "M0.0518827 8.6239L0 12.6705C0 12.7195 0.0200427 12.7664 0.0557191 12.8011C0.0913954 12.8357 0.139783 12.8552 0.190237 12.8552H1.66025L17.6574 12.8846H21.8556C22.5753 12.8902 23.2828 12.7039 23.9009 12.3459C24.519 11.9879 25.024 11.472 25.3608 10.8544C25.6975 10.2368 25.8532 9.54135 25.8107 8.84379C25.7682 8.14622 25.5293 7.47338 25.1199 6.89864C24.8898 6.60185 24.6125 6.34254 24.2984 6.13046C22.8025 5.03906 17.2294 0.971492 15.8761 0.001823C15.8618 -0.000607668 15.8472 -0.000607668 15.8329 0.001823L16.6587 5.8786L20.0181 8.19993C20.0414 8.21762 20.0585 8.2419 20.0669 8.26942C20.0754 8.29695 20.0749 8.32634 20.0654 8.35355C20.0559 8.38075 20.0379 8.40442 20.0139 8.42127C19.99 8.43811 19.9612 8.44732 19.9316 8.44759H17.0175H1.04198H0.242119C0.193129 8.44755 0.146007 8.46585 0.110569 8.49869C0.0751312 8.53153 0.0541096 8.57638 0.0518827 8.6239V8.6239Z",
                fill: "#09A6E0"
              }
            )
          ] })
        ]
      }
    )
  }
);
export {
  o as L
};
